import _ from 'lodash';

export const selectAssetForm = state => _.get(state, ['assetForm'], {});

export const selectAssetFormData = state => _.get(selectAssetForm(state), ['data'], {});
